import React from 'react';
import classNames from 'classnames';

require('./ListLoad.scss');

class ListLoad extends React.Component {
    render() {
        return (
           <div className="load-container" style={this.props.style}>
              <div className={classNames('load-model',
              { 'detail-load-model': this.props.detail },
              { 'detail-list-load-model': this.props.detailList },
              { 'detail-onepage-table-load': this.props.onePageTable }
              )} />
              <div className="load-bg" />
           </div>
        );
    }
  }
export default ListLoad;



// WEBPACK FOOTER //
// ./src/components/ListLoad/ListLoad.js